module.exports = __webpack_public_path__ + "media/images/flags/cf-cdeda2d50c2b6776a8d8fe1efb83514d.svg";